import React from 'react';
import { useParams } from 'react-router-dom';
import { ProjectForm } from '../../components/Projects';

const ProjectEdit = () => {
  return (
    <div>
      <h1>Edit Project</h1>
      <ProjectForm isEdit={true} />
    </div>
  );
};

export default ProjectEdit;


